import axios from 'axios'
let baseURL = "https://leo-edge.top";

function request() {
  const service = axios.create({
    timeout: 30000, //开始创建axios的请求时间
    withCredentials: false, //是否支持跨域
    baseURL,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
  service.interceptors.request.use( //开始对请求进行拦截
    config => {
      return config
    }, error => {
      Promise.reject(error) //如果错误，我们则使用Promise异步方法将error输出
    }
  );
  service.interceptors.response.use(
    (response) => { //response的拦截

      return response;
    }, (error) => {
      // Toast('接口错误'+error);
      return Promise.reject(error) //将错误信息返回给前端页面
    }
  );
  const service1 = axios.create({
    timeout: 30000, //开始创建axios的请求时间
    withCredentials: false, //是否支持跨域
    baseURL: baseURL,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
  service1.interceptors.request.use( //开始对请求进行拦截
    config => {
      return config
    }, error => {
      Promise.reject(error) //如果错误，我们则使用Promise异步方法将error输出
    }
  );
  service1.interceptors.response.use(
    (response) => { //response的拦截

      return response;
    }, (error) => {
      // Toast('接口错误'+error);
      return Promise.reject(error) //将错误信息返回给前端页面
    }
  );

  const service2 = axios.create({
    timeout: 30000, //开始创建axios的请求时间
    withCredentials: false, //是否支持跨域
    baseURL: baseURL,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
  service2.interceptors.request.use( //开始对请求进行拦截
    config => {
      return config
    }, error => {
      Promise.reject(error) //如果错误，我们则使用Promise异步方法将error输出
    }
  );
  service2.interceptors.response.use(
    (response) => { //response的拦截

      return response;
    }, (error) => {
      // Toast('接口错误'+error);
      return Promise.reject(error) //将错误信息返回给前端页面
    }
  );

  const service3 = axios.create({
    timeout: 30000, //开始创建axios的请求时间
    withCredentials: false, //是否支持跨域
    baseURL: baseURL,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
  service3.interceptors.request.use( //开始对请求进行拦截
    config => {
      return config
    }, error => {
      Promise.reject(error) //如果错误，我们则使用Promise异步方法将error输出
    }
  );
  service3.interceptors.response.use(
    (response) => { //response的拦截

      return response;
    }, (error) => {
      // Toast('接口错误'+error);
      return Promise.reject(error) //将错误信息返回给前端页面
    }
  );

  const service4 = axios.create({
    timeout: 30000, //开始创建axios的请求时间
    withCredentials: false, //是否支持跨域
    baseURL: baseURL,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
  service4.interceptors.request.use( //开始对请求进行拦截
    config => {
      return config
    }, error => {
      Promise.reject(error) //如果错误，我们则使用Promise异步方法将error输出
    }
  );
  service4.interceptors.response.use(
    (response) => { //response的拦截

      return response;
    }, (error) => {
      // Toast('接口错误'+error);
      return Promise.reject(error) //将错误信息返回给前端页面
    }
  );

  const service5 = axios.create({
    timeout: 30000, //开始创建axios的请求时间
    withCredentials: false, //是否支持跨域
    baseURL: baseURL,
    // baseURL: "http://cache-df.hi-silk.com.cn:8012",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
  service5.interceptors.request.use( //开始对请求进行拦截
    config => {
      return config
    }, error => {
      Promise.reject(error) //如果错误，我们则使用Promise异步方法将error输出
    }
  );
  service5.interceptors.response.use(
    (response) => { //response的拦截

      return response;
    }, (error) => {
      // Toast('接口错误'+error);
      return Promise.reject(error) //将错误信息返回给前端页面
    }
  );
  //发送真正的网络请求
  return [service, service1, service2, service3, service4, service5]
}

export default request() //导出所有axios的定义



// WEBPACK FOOTER //
// ./src/utils/request.js